export const labels = {
  1: "Very bad",
  2: "Poor",
  3: "Ok",
  4: "Good",
  5: "Very good",
};
